import { gql } from 'urql';

export const AdvanceExternalPaymentVerificationQuery = gql`
  query AdvanceExternalPaymentVerification(
    $input: AdvanceExternalPaymentVerificationInput
  ) {
    advanceExternalPaymentVerification(input: $input) {
      __typename
      ... on AdvanceExternalPaymentVerificationSuccess {
        validCard
      }
      ... on AdvanceExternalPaymentVerificationLinkCard {
        externalInstitutionName
        externalInstitutionLastFour
      }
      ... on AdvanceExternalPaymentVerificationManageCard {
        validCard
      }
      ... on AdvanceExternalPaymentVerificationError {
        message
        code
      }
    }
  }
`;
